import { ReactElement } from "react";

export function Register(): ReactElement {
  return <>Register</>;
}
